"use client";

import { createContext, useContext } from "react";

export const TabContainerContext = createContext(false);

export function useInsideTabContainer(): boolean {
  return useContext(TabContainerContext);
}
